import { formatUTCToTimestamp } from '../utils/convertUTCtoTime';
import WOIcon from './../assets/images/WO icon.png';
const EmailHeader = ({ timeStamp }: { timeStamp: string }) => {
  return (
    <header className="p-6">
      <h1 className="text-[16px] font-roboto text-tab-text font-semibold">
        Makegood Recommendations
      </h1>
      <div className="flex mt-3 justify-between items-center">
        <div className="flex items-center">
          <img src={WOIcon} alt="WO Logo" className="w-10 h-10 mr-4" />
          <div>
            <p className="text-sm text-gray-600">
              <span className="text-tab-text text-[16px] font-roboto font-semibold">
                WideOrbit [noreply@wideorbit.com]
              </span>
            </p>
            <p className="text-[11px] text-tab-grey">To: Sally Seller</p>
          </div>
        </div>
        <div>
          <p className="text-[11px] text-tab-grey">
            {timeStamp ? formatUTCToTimestamp(timeStamp) : null}
          </p>
        </div>
      </div>
    </header>
  );
};
export default EmailHeader;
